"use client";

export { ImageProvider } from "@scott/ui/elements/image/image-provider";
